// XXX TODO FIXME autogen this from site.go; lotsa dupe data
let current_site_id;
let short_site_id;
let default_currency;
let site_base;
let site_name;
let default_market;
if (IS_BT) {
	current_site_id = "BT";
	short_site_id = "BT";
	default_currency = "DKK";
	site_base = "aktiespil.bt.dk";
	site_name = "BT"
    default_market = "DK_STOCK";
} else if (IS_BERLINGSKE) {
    current_site_id = "BERLINGSKE";
	short_site_id = "BE";
	default_currency = "DKK";
	site_base = "aktiespil.berlingske.dk";
	site_name = "Berlingske"
    default_market = "DK_STOCK";
} else if (IS_EUROINVESTOR) {
	current_site_id = "EUROINVESTOR";
	short_site_id = "EI";
	default_currency = "DKK";
	site_base = "aktiespil.euroinvestor.dk";
	site_name = "Euroinvestor"
    default_market = "DK_STOCK";
} else if (IS_TEST) {
    current_site_id = "TEST";
	short_site_id = "TT";
	default_currency = "DKK";
	site_base = "berlingske.itstack.dev";
	site_name = "TEST"
    default_market = "DK_STOCK";
}

export {
	current_site_id,
	short_site_id,
	default_currency,
	site_base,
	site_name,
    default_market,
}



// WEBPACK FOOTER //
// ./src/Site.js